/**
 * PWA entry. Stamps the browser-side `window.app` facade BEFORE the React
 * tree mounts so any shared module that references `window.app.X(...)`
 * (use-audio-stream, CodeView) finds the browser implementation rather
 * than the Electron preload (which doesn't exist here).
 */
import { createRoot } from 'react-dom/client';
import { browserApi } from './api';

// Stamp the browser-side `window.app` BEFORE any module that imports it
// from the shared renderer tree (use-audio-stream, CodeView, etc.) is
// evaluated. The dynamic import below ensures Overlay's transitive imports
// run after this assignment.
(window as unknown as { app: typeof browserApi }).app = browserApi;

// One-time PWA defaults migration. The shared store defaults Config chip
// and Auto-collapse to ON (desktop's preferred state); on mobile we want a
// quieter shell — only Auto-ask lit. Existing users' explicit preferences
// (any value already in localStorage) are preserved.
if (localStorage.getItem('caption.pwa.defaultsApplied') === null) {
  if (localStorage.getItem('caption.showConfigChip') === null) {
    localStorage.setItem('caption.showConfigChip', '0');
  }
  if (localStorage.getItem('caption.autoCollapse') === null) {
    localStorage.setItem('caption.autoCollapse', '0');
  }
  localStorage.setItem('caption.pwa.defaultsApplied', '1');
}

// Load styles up-front. Order matters — mobile overrides win at equal
// specificity, so they must come after the desktop base.
import '../renderer/src/styles.css';
import './styles.mobile.css';

void import('./Overlay').then(({ Overlay }) => {
  const root = document.getElementById('root');
  if (!root) throw new Error('#root not found');
  createRoot(root).render(<Overlay />);
});
